const notificationSound = new Audio("/notification-bell.mp3");
notificationSound.preload = "auto";

let audioUnlocked = false;

export const unlockNotificationSound = async () => {

    if (audioUnlocked) return;

    try {

        await notificationSound.play();

        notificationSound.pause();
        notificationSound.currentTime = 0;

        audioUnlocked = true;

        console.log("Audio unlocked");

    } catch (error) {

        console.log(error);
    }
};